import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { Picker, Drawer, List } from 'antd-mobile'
import * as styles from './style/index.scss'
import IconArrowRight from '@assets/img/global/icon-arrow-right.png'

import US_IMG from '@assets/img/global/country/US.png'
import AT_IMG from '@assets/img/global/country/AT.png'
import BE_IMG from '@assets/img/global/country/BE.png'
import CH_IMG from '@assets/img/global/country/CH.png'
import DE_IMG from '@assets/img/global/country/DE.png'
import DK_IMG from '@assets/img/global/country/DK.png'
import ES_IMG from '@assets/img/global/country/ES.png'
import FI_IMG from '@assets/img/global/country/FI.png'
import FR_IMG from '@assets/img/global/country/FR.png'
import IE_IMG from '@assets/img/global/country/IE.png'
import IT_IMG from '@assets/img/global/country/IT.png'
import LUX_IMG from '@assets/img/global/country/LUX.png'
import NL_IMG from '@assets/img/global/country/NL.png'
import NO_IMG from '@assets/img/global/country/NO.png'
import PT_IMG from '@assets/img/global/country/PT.png'
import SE_IMG from '@assets/img/global/country/SE.png'
import GB_IMG from '@assets/img/global/country/GB.png'
import { REGION_V } from '@src/constants'
import { FormattedMessage } from 'react-intl'
import intl from '@utils/intl'

interface RegionProps {
    subAreas: any[]
    changeRegion: (option) => void
}
const Item = List.Item
class SwitchRegion extends ComponentExt<RegionProps, any> {
    private regionObj = {
        [REGION_V.AT]: AT_IMG,
        [REGION_V.BE]: BE_IMG,
        [REGION_V.CH]: CH_IMG,
        [REGION_V.DE]: DE_IMG,
        [REGION_V.DK]: DK_IMG,
        [REGION_V.ES]: ES_IMG,
        [REGION_V.FI]: FI_IMG,
        [REGION_V.FR]: FR_IMG,
        [REGION_V.IT]: IT_IMG,
        [REGION_V.IE]: IE_IMG,
        [REGION_V.LUX]: LUX_IMG,
        [REGION_V.NL]: NL_IMG,
        [REGION_V.NO]: NO_IMG,
        [REGION_V.PT]: PT_IMG,
        [REGION_V.SE]: SE_IMG,
        [REGION_V.GB]: GB_IMG,
        [REGION_V.US]: US_IMG,
    }

    constructor(props) {
        super(props)
        this.state = {
            currentCargoType: '',
            currentRegionCode: '',
            open: false
        }
    }

    buildRegionList = (list) => {
        const arr = []
        list.map(item => {
            arr.push({
                label: (
                    <div className={styles.pickerItem}>
                        <img src={this.regionObj[item.childAreaCode]} className={styles.pickerItemImg} />
                        <span>{item.childAreaName}</span>
                    </div>
                ),
                value: item.childAreaCode,
                text: item.childAreaName
            })
        })
        return arr
    }

    changeRegion = value => {
        const cargoType = this.props.subAreas.find(item => item.childAreaCode === value[0]).cargoType
        this.setState({
            currentCargoType: cargoType,
            currentRegionCode: value[0]
        })
        const areaId = this.props.subAreas.find(item => item.childAreaCode === value[0]).parentAreaId
        const countryName = this.props.subAreas.find(item => item.childAreaCode === value[0]).childAreaName
        this.props.changeRegion({ cargoType: cargoType, areaId: areaId, countryName: countryName, countryCode: value[0] })
        this.onOpenChange()
    }

    stopWindowMove = () => {
        setTimeout(() => {
            const popupDom = document.getElementsByClassName('am-picker-popup-content')[0]
            popupDom.addEventListener('touchmove', (e) => {
                e.stopPropagation();
            }, false)
        }, 200)
    }
    drawerList = (list) => {
        return (
            <List className={styles.areaContens} style={{ height: document.body.clientHeight - 45 }}>
                {list.map((item, index) =>
                    <Item className={styles.draItem} style={{ backgroundColor: this.state.currentRegionCode === item.childAreaCode ? '#eee' : '' }} key={index} onClick={() => this.changeRegion([item.childAreaCode])}>
                        <img src={this.regionObj[item.childAreaCode]} className={styles.draimg} />
                        <span>{item.childAreaName}</span>
                    </Item>
                )}
            </List>
        )
    }
    openDra = () => {
        this.setState({
            open: true,
        })
        if (!this.state.currentRegionCode) {
            this.setState({
                currentRegionCode: this.props.subAreas[0].childAreaCode
            })
        }
        document.querySelector('body').style.overflow = 'hidden';
    }
    onOpenChange = () => {
        this.setState({
            open: !this.state.open
        })
        document.querySelector('body').style.overflow = 'auto';
    }
    render() {
        if (this.props.subAreas.length === 0) {
            return <></>
        }
        const value = this.state.currentRegionCode || this.props.subAreas[0].childAreaCode
        const currentRegionCode = this.state.currentRegionCode || this.props.subAreas[0].childAreaCode
        const labelForShow = this.props.subAreas.find(item => item.childAreaCode === value).childAreaName
        const isTable = localStorage.getItem('chl') == 'tabletApp'

        return (
            <div className={styles.regionWrap}>
                <FormattedMessage id="home.area.switch.title" />
                {
                    isTable ? <div>
                        <div className={styles.regionSelectWrap} onClick={this.openDra}>
                            <img src={this.regionObj[currentRegionCode]} />
                            <span>{labelForShow}</span>
                            <img src={IconArrowRight} />
                        </div>
                        {this.state.open && <Drawer
                            className="my-drawer"
                            style={{ minHeight: document.documentElement.clientHeight }}
                            // enableDragHandle
                            contentStyle={{ color: '#A6A6A6', textAlign: 'center', paddingTop: 42 }}
                            sidebar={this.drawerList(this.props.subAreas)}
                            open={this.state.open}
                            onOpenChange={this.onOpenChange}
                        ><></></Drawer>}
                    </div> : <Picker
                        data={this.buildRegionList(this.props.subAreas)}
                        cols={1}
                        value={[value]}
                        okText={intl.formatMessage({ id: 'common.sure' })}
                        dismissText={intl.formatMessage({ id: 'common.cancel' })}
                        onChange={this.changeRegion}
                    >
                        <div className={styles.regionSelectWrap} onTouchEnd={this.stopWindowMove}>
                            <img src={this.regionObj[currentRegionCode]} />
                            <span>{labelForShow}</span>
                            <img src={IconArrowRight} />
                        </div>
                    </Picker>
                }
            </div>
        )
    }
}

export default SwitchRegion
